/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { DiagnosticLogicIcon, FeedbackProviderTagScore } from '@app/app/shared/models';
import { EditorContent } from './editor-content.model';

export interface ChartLearner {
  imageUrl: string;
  firstName: string;
}

export interface ChartContent extends EditorContent {
  uid?: string;
  chartType: ChartType;
  items: ChartItem[];
  showPercentage: boolean;
  versionedScores: ChartVersionScore[];
  iconXMax?: string;
  iconXMin?: string;
  feedbackProviders?: FeedbackProviderTagScore[];
  radarChartColorScheme?: RadarChartColorScheme;
  // front-end specific
  showStaticChart: boolean;
  shouldSaveChart: boolean;
}

export interface RadarChartColorScheme {
  selfRatingColor: string;
  feedbackProvidersColor: string;
}

export interface ChartVersionScore {
  completedOn: Date;
  version: number;
  scores: ChartVersionScoreItem[];
}

export interface ChartVersionScoreItem {
  maxScore: number;
  tagId: string;
  userScore: number;
  scoredLevel: {
    levelUid: string;
    scoreRange: {
      min: number;
      max: number;
    };
  };
}

export type ChartType = 'RADAR' | 'RADIAL' | 'BAR' | 'HISTOGRAM' | 'PROGRESS';

const chartTypeLabels: Record<ChartType, string> = {
  RADAR: 'Radar',
  RADIAL: 'Radial',
  BAR: 'Bar',
  HISTOGRAM: 'Histogram',
  PROGRESS: 'Progress',
};

export function getChartLabel(type: ChartType): string {
  return chartTypeLabels[type];
}

export interface ChartItem {
  itemUid: string;
  color: string;
  title?: string;
  total?: number;
  scored?: number;
  sectionUid?: string;
  icon?: DiagnosticLogicIcon;
  feedbackProviderTagScores?: FeedbackProviderTagScore[];
}

export interface ChartDataLabels {
  label: string;
  top: number;
  left: number;
  transform: string;
  feedbackProviderTagScores?: FeedbackProviderTagScore[];
  allFeedbackProvidersAvgScore?: number;
  userScorePercent?: number;
  userRawScore?: number;
  userMaxScore?: number;
  avgRawScore?: number;
  feedbackScorePercent?: number;
  totalPossible?: number;
}
